import { Component, ElementRef, Input, OnInit, OnChanges } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'uex-icon',
  template: '{{getValue()}}',
  host: {
    class: 'uex-icon'
  }
})
export class IconComponent implements OnInit, OnChanges {
  @Input() mode: IconMode = 'md';
  @Input() color: string;
  @Input() size: string;
  @Input() name: string;

  constructor(
    private elementRef: ElementRef
  ) { }

  private _classes: Array<string> = [];

  public ngOnInit() {
    this._updateClasses();
  }

  public ngOnChanges() {
    this._updateClasses();
  }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public getValue(): string {
    switch (this.mode) {
      case 'fa':
      case 'fas':
      case 'far':
      case 'fab':
      case 'uex':
        return null;
      default:
        return this.name;
    }
  }

  private _updateClasses() {
    this._clearClasses();

    switch (this.mode) {
      case 'fa':
      case 'fas':
      case 'far':
      case 'fab':
        this._classes.push(this.mode);
        this._classes.push('fa-fw');
        this._classes.push(`fa-${this.name}`);
        break;
      case 'uex':
        this._classes.push(`uex-custom-icons`);
        this._classes.push(`uex-custom-icon-${this.name}`);
        break;
      default:
        this._classes.push('material-icons');
    }

    const size_class = this._getSizeClass();
    if (size_class) { this._classes.push(size_class); }

    const color_class = this._getColorClass();
    if (color_class) { this._classes.push(color_class); }

    this._setClasses();
  }

  private _clearClasses() {
    if (this._classes) {
      const current_classes = this.elementRef.nativeElement.className.split(' ');
      this._classes.forEach((_class) => {
        const index = current_classes.indexOf(_class);
        if (index > -1) { current_classes.splice(index, 1); }
      });
      this._classes = [];
      this.elementRef.nativeElement.className = current_classes.join(' ');
    }
  }

  private _setClasses() {
    const current_classes = this.elementRef.nativeElement.className.split(' ').filter((i) => !!i);
    this.elementRef.nativeElement.className = _.concat(current_classes, this._classes).join(' ');
  }

  private _getSizeClass(): string {
    switch (this.size) {
      case '2x':
      case 'large':
      case 'lg':
        return 'size-2x';
      case '3x':
      case 'xlarge':
      case 'xl':
        return 'size-3x';
      case '4x':
      case 'xxlarge':
      case 'xxl':
        return 'size-4x';
      case '5x':
      case 'xxxlarge':
      case 'xxxl':
        return 'size-5x';
      default: return null;
    }
  }

  private _getColorClass(): string {
    if (!this.color) { return; }
    return `text-${this.color}`;
  }
}

export type IconMode = 'md' | 'fa' | 'fas' | 'far' | 'fab' | 'uex';
